module.exports = __webpack_public_path__ + "static/img/result_desk_ust.ec7a544.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_desk_ust.jpg
// module id = lV/s
// module chunks = 3